import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiTableModule} from '@snelstart/ui-table';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {FeatureTaxMumaListComponent} from "./tax-muma-list/feature-tax-muma-list.component";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiAlertModule, SharedUiDialogModule, FeatureTaxMumaListComponent],
  declarations: [],
  exports: [FeatureTaxMumaListComponent],
})
export class FeatureTaxMumaListModule {
}
